export const privacyPolicy = process.env.REACT_APP_PRIVACY_POLICY_URL || '';
export const privacyPolicyMobile =
  process.env.REACT_APP_PRIVACY_POLICY_URL_MOBILE || '';
export const termsOfService = process.env.REACT_APP_TERMS_OF_SERVICE_URL || '';
export const termsOfServiceMobile =
  process.env.REACT_APP_TERMS_OF_SERVICE_URL_MOBILE || '';
export const howToUse = process.env.REACT_APP_HOW_TO_USE_URL || '';
export const deleteFunction = process.env.REACT_APP_DELETE_FUNCTION_URL || '';
